/**
 * @constructor
 * @implements {Foundation.View.Interface.ModalDialog}
 * @param {jQuerySelector?} viewSelector
 * @extends {Foundation.Promise}
 */
Foundation.View.Responsive.ModalDialog = function (viewSelector) {
  Foundation.Promise.call(this);

  /** @type {Foundation.Spinner} */
  this.spinner = null;

  /** @type {!Foundation.Promise} */
  this.closedPromise = new Foundation.Promise();

  /** @type {jQuery} */
  this.view = null;
  this.setView(viewSelector);
};
Foundation.inherit(Foundation.View.Responsive.ModalDialog, Foundation.Promise);

Foundation.View.Responsive.ModalDialog.prototype.closed = function () {
  return this.closedPromise;
};

/**
 * @param {jQuerySelector?} viewSelector
 */
Foundation.View.Responsive.ModalDialog.prototype.setView = function (viewSelector) {
  Foundation.documentReady.then(function () {
    if (!viewSelector) {
      this.spinner = new Foundation.View.Spinner();
    }
    else {
      if (this.spinner) this.spinner.hide();
      this.view = jQuery(viewSelector);

      var modalWrap = jQuery("<div>").addClass("login-modal-wrap")
      var modalBody = jQuery("<div>").addClass("uk-modal-dialog")
      this.view.appendTo(modalBody);

      modalWrap.append(modalBody)

      jQuery("body").append(modalWrap)

      var el = modalWrap[0]

      this.view = modalWrap;

      try {
        UIkit.modal(el, {});

        this.view.on("show", () => {
          this.fulfill()
        })

        this.view.on("hide", () => {
          this.closed().fulfill()
        })

        /*global UIkit */
        UIkit.modal(el).show()
      }
      catch (e) {
        // console.error(e)
      }
    }
  }.bind(this));
};

/**
 * Close the dialog.
 */
Foundation.View.Responsive.ModalDialog.prototype.close = function () {
  if (this.spinner) {
    this.spinner.hide();
  }
  this.then(function () {
    if (this.view) {
      UIkit.modal(this.view[0]).hide();
    }
  }.bind(this));
};

/**
 * Destructor. Will remove the dialog page element from the DOM.
 * @override
 */
Foundation.View.Responsive.ModalDialog.prototype.destroy = function () {
  if (this.spinner) this.spinner.hide();
  if (this.view) {
    //this.view.remove();
    this.view = null;
  }
  Foundation.Promise.prototype.destroy.call(this);
};

/**
 * On a redraw, bring the user back up to the top of the dialog.
 */
Foundation.View.Responsive.ModalDialog.prototype.redraw = function () {
  //jQuery.mobile.silentScroll(0);
  //this.view.modal('refresh');
};


Foundation.View.ModalDialog = Foundation.View.Responsive.ModalDialog;


